module.exports = __webpack_public_path__ + "static/img/Risk240121TW.f1a87a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Risk240121TW.jpg
// module id = Dk9M
// module chunks = 1